var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "py-6" }, [
    _c("h3", { staticClass: "text-lg font-medium mb-4" }, [
      _vm._v("Step 3 of 9: Language & Communication"),
    ]),
    _c(
      "div",
      { staticClass: "grid grid-cols-1 gap-3" },
      [
        _c("ValidationProvider", {
          attrs: { name: "Languages Spoken" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v("Languages Spoken "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormSelect", {
                        key: `languages_spoken_${_vm.languages.length}`,
                        attrs: {
                          name: "communication_languages_spoken",
                          placeholder: "Select languages spoken",
                          getParentCustom: "clientWidth",
                          options: _vm.languageOptions,
                          inputClass: "w-full",
                          multiple: "",
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField(
                              "communication_languages_spoken",
                              val
                            ),
                        },
                        model: {
                          value:
                            _vm.localFormData.communication_languages_spoken,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.localFormData,
                              "communication_languages_spoken",
                              $$v
                            )
                          },
                          expression:
                            "localFormData.communication_languages_spoken",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("ValidationProvider", {
          attrs: { name: "Preferred Language" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v("Preferred Language"),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v(" (optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormSelect", {
                        key: `preferred_language_${_vm.languages.length}`,
                        attrs: {
                          name: "preferred_language",
                          placeholder: "Select preferred language",
                          getParentCustom: "clientWidth",
                          inputClass: "w-full",
                          options: _vm.languageOptions,
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField("preferred_language", val),
                        },
                        model: {
                          value: _vm.localFormData.preferred_language,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.localFormData,
                              "preferred_language",
                              $$v
                            )
                          },
                          expression: "localFormData.preferred_language",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("ValidationProvider", {
          attrs: { name: "Interpreter Needed" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v("Interpreter Needed"),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          getParentCustom: "clientWidth",
                          name: "interpreter_needed",
                          placeholder: "Select interpreter needed",
                          options: [
                            { label: "Yes", value: "Yes" },
                            { label: "No", value: "No" },
                          ],
                          inputClass: "w-full",
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField("interpreter_needed", val),
                        },
                        model: {
                          value: _vm.localFormData.interpreter_needed,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.localFormData,
                              "interpreter_needed",
                              $$v
                            )
                          },
                          expression: "localFormData.interpreter_needed",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _c("ValidationProvider", {
          attrs: { name: "Communication Style" },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function ({ errors }) {
                return [
                  _c(
                    "FormGroup",
                    {
                      attrs: { title: "", errors: errors },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v("Preferred Communication Style"),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v(" (optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          getParentCustom: "clientWidth",
                          name: "preferred_communication_style",
                          placeholder: "Select preferred communication style",
                          inputClass: "w-full",
                          options: [
                            { label: "Verbal", value: "Verbal" },
                            { label: "Text", value: "Text" },
                            { label: "Email", value: "Email" },
                            { label: "Visual", value: "Visual" },
                          ],
                        },
                        on: {
                          input: (val) =>
                            _vm.updateField(
                              "preferred_communication_style",
                              val
                            ),
                        },
                        model: {
                          value:
                            _vm.localFormData.preferred_communication_style,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.localFormData,
                              "preferred_communication_style",
                              $$v
                            )
                          },
                          expression:
                            "localFormData.preferred_communication_style",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        }),
        _vm.localFormData.preferred_communication_style
          ? _c("ValidationProvider", {
              attrs: { name: "Visual Communication Style" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function ({ errors }) {
                      return [
                        _c(
                          "FormGroup",
                          {
                            attrs: { title: "", errors: errors },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "title",
                                  fn: function () {
                                    return [
                                      _c("p", { staticClass: "mb-2" }, [
                                        _vm._v("Visual Communication Style "),
                                        _c("span", { staticClass: "subText" }, [
                                          _vm._v("(optional)"),
                                        ]),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("FormSelect", {
                              attrs: {
                                getParentCustom: "clientWidth",
                                name: "visual_communication_style",
                                placeholder: "Select visual communication",
                                inputClass: "w-full",
                                options: [
                                  { label: "Written", value: "written" },
                                  {
                                    label: "Sign Language",
                                    value: "sign_language",
                                  },
                                  {
                                    label: "Picture Cards",
                                    value: "picture_cards",
                                  },
                                  { label: "Gestures", value: "gestures" },
                                ],
                              },
                              on: {
                                input: (val) =>
                                  _vm.updateField(
                                    "visual_communication_style",
                                    val
                                  ),
                              },
                              model: {
                                value:
                                  _vm.localFormData.visual_communication_style,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.localFormData,
                                    "visual_communication_style",
                                    $$v
                                  )
                                },
                                expression:
                                  "localFormData.visual_communication_style",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                1901868643
              ),
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }